const info = {
  fname: "Kevin",
  lname: "Philip",
  title: "Software Engineering Student",
  location: "Dallas, TX",
  phone: "(972) 975-8323",
  email: "thekevinphilip@gmail.com",
  linkedin: "linkedin.com/in/kevinphilip0",
  github: "github.com/kphilippp",
  website: "kphilip.cv",
  degree: "Bachelor of Science, Software Engineering",
  university: "The University of Texas at Dallas",
  graduationDate: "Expected May 2026",
  gpa: "3.7",
  mastersDegree: "Master of Science, Computer Science – Intelligent Systems",
  mastersGraduationDate: "Expected May 2028",
};

export default info;
